import type { StyledComponent } from '@emotion/styled';
import { Box, Button, darken, lighten, styled } from '@mui/material';

export const SearchContainer: StyledComponent<any> = styled(Box)(
  ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr auto',
    },
  })
);

export const ButtonsContainer: StyledComponent<any> = styled(Box)(
  ({ theme }) => ({
    gap: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  })
);

export const FilterButton: StyledComponent<any> = styled(Button)(
  ({ theme }) => ({
    backgroundColor: '#d8d8d8',
    color: theme.palette.common.black,
    fontSize: theme.typography.fontSize,
    [theme.breakpoints.up('md')]: {
      minWidth: '120px',
    },
    '&:hover': {
      backgroundColor: darken('#d8d8d8', 0.2),
      color: theme.palette.common.black,
    },
    '& span': {
      marginLeft: theme.spacing(2),
    },
    '&.showFilters': {
      '&:hover': {
        backgroundColor: lighten('#232736', 0.2),
      },
      backgroundColor: '#232736',
      color: theme.palette.common.white,
    },
  })
);
